import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // tab切换的name
      activeName: "1",
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        typeCode: null, // 编码
        typeName: null, // 名称
        tradeType: null, // 注册类型
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "专业名称：",
          value: "typeName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "专业编码：",
          value: "typeCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "注册类型：",
          value: "tradeType",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507131626360048"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "专业名称",
          prop: "typeName",
          isShow: true,
        },
        {
          label: "专业编码",
          prop: "typeCode",
        },
        {
          label: "注册类型",
          prop: "tradeTypeName",
        },
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 请求路径
      reqUrl: "/regTradeType/list",
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 判断是否有详情页面返回的值
    this.activeName = this.$route.query.activeName ? this.$route.query.activeName : "1";
    // 如果是项目负责人注册专业
    if (this.activeName === "1") {
      // 显示项目负责人注册专业
      this.fun_GetShowRegTradeType();
      // 更换请求路径
      this.reqUrl = "/regTradeType/list";
    } else {
      // 显示项目负责人注册等级
      this.fun_GetShowRegTradeLevel();
      // 更换请求路径
      this.reqUrl = "/regTradeLevel/list";
    }
    // 重置分页
    this.reqPageData = {
      current: 1, // 页码
      size: 10 // 每页条数
    };
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction(this.reqUrl, {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 子传父
      this.$router.push({path: "/regTradeTypeDetail", query: {id:e.val.id, type: "details", activeName: this.activeName, }});
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      this.$router.push({path: "/regTradeTypeDetail", query: { type: "insert", activeName: this.activeName, }});
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          this.$router.push({path: "/regTradeTypeDetail", query: {id:this.multipleSelection[0].id,  type: "update", activeName: this.activeName, }});
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 声明
          var delUrl = "/regTradeType/delete";
          // 判断
          if(this.activeName === "1"){
            // 更换路径
            delUrl = "/regTradeType/delete";
          }else{
            // 更换路径
            delUrl = "/regTradeLevel/delete";
          }
          // 请求，获取结果集
          fun_PostAction(delUrl, {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { result,msg } = res.data;
            // 判断
            if(result){
              // 操作成功
              this.$message.success(msg);
              // 获取一览表格数据
              this.fun_GetList();
            }else{
              // 提示请求失败消息
              this.$message.error(msg);
            }
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 项目负责人注册专业需要显示的内容
     */
    fun_GetShowRegTradeType(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form = {
        typeCode: null, // 编码
        typeName: null, // 名称
        tradeType: null, // 注册类型
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "input",
          label: "专业名称：",
          value: "typeName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "专业编码：",
          value: "typeCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "注册类型：",
          value: "tradeType",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507131626360048"
          }
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "专业名称",
          prop: "typeName",
          isShow: true,
        },
        {
          label: "专业编码",
          prop: "typeCode",
        },
        {
          label: "注册类型",
          prop: "tradeTypeName",
        },
      ];
    },
    /**
     * 项目负责人注册专业需要显示的内容
     */
    fun_GetShowRegTradeLevel(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form = {
        tradeType: null, // 注册类型
        typeLevelName: null, // 注册等级名称
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "select",
          label: "注册类型：",
          value: "tradeType",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/DictionaryCombobox",
            zdid: "201507131626360048"
          }
        },
        {
          type: "input",
          label: "注册等级名称：",
          value: "typeLevelName",
          placeholder: "请输入",
          clearable: true
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "注册类型",
          prop: "tradeTypeName",
          isShow: true,
        },
        {
          label: "注册等级编码",
          prop: "typeLevelNum",
        },
        {
          label: "注册等级名称",
          prop: "typeLevelName",
        },
        {
          label: "注册等级编号",
          prop: "typeLevelNo",
        },
      ];
    },
    /**
     * @description 切换tabs
     * @author
     */
    fun_HandleClick(tab, event) {
      // 切换标签页
      this.activeName = tab.name;
      // 如果是项目负责人注册专业
      if (tab.name === "1") {
        // 显示项目负责人注册专业
        this.fun_GetShowRegTradeType();
        // 更换请求路径
        this.reqUrl = "/regTradeType/list";
      } else {
        // 显示项目负责人注册等级
        this.fun_GetShowRegTradeLevel();
        // 更换请求路径
        this.reqUrl = "/regTradeLevel/list";
      }
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
